import { Locales } from './interfaces';
import { WithLocales } from './localesContext';
import ReportsComponent, { CommonProps } from './reportsComponent';

interface Props extends CommonProps<unknown> {
  locales: Locales;
}

const Reports = ({ locales, ...props }: Props) => (
  <WithLocales locales={locales}>
    <ReportsComponent {...props} />
  </WithLocales>
);

export default Reports;
